import { Injectable } from 'injection-js';
import { Http, Module } from 'shared/core';
import { DoubleClickProtectionElement } from 'shared/elements';
import { Flash } from 'shared/lib';
import * as dayjs from 'dayjs';


@Injectable()
export class PickUpModule extends Module {
  private http: Http;

  constructor(http: Http) {
    super();
    this.http = http;
  }

  init(): void {
    if($('.returns-delivery-pick-up-date').data('requiresPickup') === true && $('#pickUpDate').val() === '') {
      $('.nextBtn').prop('disabled', true)
    }

    $('body').on('click', '[data-pickup-gate]', e => {
      if ($('.returns-delivery-pick-up-date').data('requiresPickup') === true &&
          $('.returns-delivery-pick-up-date p').length === 0) {
        e.preventDefault();
        Flash.genericAlert('Please select a pick-up date before continuing.');
      }
    });

    $('body').on('click', '#dateSelectBtn', async e => {
      const date = $('#pickUpDate').val() as string;
      const $container = $(e.target).closest('.flex-row');
      const id = $(e.target).data('id');
      const formData = window.App.newFormData();
      formData.append('date', date);

      if (!date) {
        return;
      }

      DoubleClickProtectionElement.disableContainer($container)
      const response: any =  await this.http.post(`/returns/${id}/request_pick_up_time`, formData)
      DoubleClickProtectionElement.enableContainer($container);

      if (response.success) {
        const data = response.data;
        const element = document.createElement('p');

        if (data.next_business_day) {
          element.classList.add('red');
          element.innerHTML = `Your parcel cannot be picked up on your chosen date, \
            ${dayjs(data.requested_pick_up_date).format('DD/MM/YYYY')}, but can be picked up on the next business day, 
            <b>${dayjs(data.pick_up_date).format('DD/MM/YYYY')}</b>.`
        } else {
          element.innerHTML = `Your parcel will be picked up on <b>${dayjs(data.pick_up_date).format('DD/MM/YYYY')}</b>.`
        }

        $('.returns-delivery-pick-up-date').empty().append(element);
        $('.returns-delivery-pick-up-time').empty().append(`
            Your package will be picked up between <b>${dayjs(data.pick_up_earliest).format('H:mm')}</b> and
            <b>${dayjs(data.pick_up_latest).format('H:mm')}</b>.
        `);

        $('.nextBtn').prop('disabled', false)
      } else {
        $('.returns-delivery-pick-up-date').empty();
        $('.returns-delivery-pick-up-time').empty();
        Flash.genericAlert(response.error_message);
      }
    });
  }
}
